import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Users } from 'lucide-react';

interface InvitationAlertProps {
  invitationCode?: string;
  invitationData?: {
    organization: {
      name: string;
      logo?: string;
    };
  };
}

export function InvitationAlert({ invitationCode, invitationData }: InvitationAlertProps) {
  if (!invitationCode || !invitationData)
    return (
      <div className="rounded-md bg-yellow-50 p-4">
        <div className="flex">
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">Invitation No Longer Valid</h3>
            <div className="mt-2 text-sm text-yellow-700">
              <p>
                The invitation you&apos;re trying to use is no longer valid or has been withdrawn. You can still create
                a personal account.
              </p>
            </div>
          </div>
        </div>
      </div>
    );

  return (
    <Alert className="mb-6 border-primary/20 bg-primary/5 text-primary">
      <div className="flex items-start gap-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/20">
          <Users className="h-5 w-5 text-primary" />
        </div>
        <div className="space-y-1">
          <AlertTitle className="text-base font-semibold text-primary">You&apos;ve been invited!</AlertTitle>
          <AlertDescription className="text-primary">
            Your account will be automatically linked to{' '}
            <span className="font-bold text-primary">{invitationData.organization.name}</span> upon registration.
          </AlertDescription>
        </div>
      </div>
    </Alert>
  );
}
